// Child car seats offered as booking extras. Customer-provided Kinderkraft images.
export const CHILD_SEATS = [
  {
    id: "babyschale",
    name: "Babyschale",
    ages: "0–15 Monate",
    weight: "0–13 kg",
    price: 15,
    slug: "babyschale-mieten",
    image: "https://customer-assets-gfyr7b9c.emergentagent.net/job_suisse-lane/artifacts/axi5nhe4_IMG_2193.webp",
    desc: "Gruppe 0+ für Neugeborene und Säuglinge. Fachgerecht montiert und geprüft.",
  },
  {
    id: "kindersitz",
    name: "Kindersitz",
    ages: "1–12 Jahre",
    weight: "9–36 kg",
    price: 15,
    slug: "kindersitz-mieten",
    image: "https://customer-assets-gfyr7b9c.emergentagent.net/job_suisse-lane/artifacts/8001r5hf_IMG_2191.webp",
    desc: "Gruppe 1/2/3 mit hoher Rückenlehne und Seitenaufprallschutz.",
  },
  {
    id: "sitzerhoehung",
    name: "Sitzerhöhung",
    ages: "6–12 Jahre",
    weight: "22–36 kg",
    price: 10,
    slug: "sitzerhoehung-mieten",
    image: "https://customer-assets-gfyr7b9c.emergentagent.net/job_suisse-lane/artifacts/ms4o4uin_IMG_2192.webp",
    desc: "Gruppe 3 für den optimalen Gurtverlauf bei grösseren Kindern.",
  },
];
